<template>
  <div class="container">
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <router-link tag="div" :to="'/detail/' + item.id" class="detail border-bottom" v-for="item in alist" :key="item.id">
        <img :src="item.imgUrl ? url + item.imgUrl : defaultimg">
        <h5>{{item.title}}</h5>
        <p>库存：<span>{{item.stock}}</span></p>
        <span class="dollars">¥<span class="price"> {{item.price}}</span></span>
      </router-link>
      <img class="empty" src="/static/img/mescroll-empty.png" v-show="show">
      <div slot="infinite-scroll-loading">loading...</div>
      <div slot="completed">没有更多商品了~</div>
    </vue-data-loading>
  </div>
</template>

<script>
// 引入上拉加载组件
import VueDataLoading from 'vue-data-loading'
import url from '@/common/common.js'
export default {
  name: 'GoodsList',
  props: {
    list: Array
  },
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      loading: false,
      completed: false,
      num: 1,
      size: 10,
      alist: [],
      show: false,
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.getGoodsInfo()
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getGoodsInfo () {
      // 联网请求
      this.axios.get('/ApiGoodList/GetList', {
        params: {
          id: this.$route.params.id,
          num: this.num, // 页码
          size: this.size
        }
      }).then(this.getGoodsInfoSucc)
        .catch(this.getGoodsInfoFail)
    },
    getGoodsInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        // this.list.push(JSON.parse(data.goodsList))
        var newList = JSON.parse(data.goodsList)
        if (JSON.parse(data.goodsList).length === 0) {
          this.completed = true
          this.loading = false
          this.show = true
        } else {
          for (var i = 0; i < newList.length; i++) {
            setTimeout(() => {
              // console.log(JSON.parse(data.goodsList).length)
              if (JSON.parse(data.goodsList).length < 10) {
                this.completed = true
                this.loading = false
                this.show = false
                return
              }
              const temp = []
              for (let i = newList.length + 1; i <= newList.length + 50; i++) {
                temp.push(i)
              }
              newList = newList.concat(temp)
              this.loading = false
            }, 1000)
            this.alist.push(newList[i])
            // console.log(this.alist)
          }
        }
      }
      // console.log(newList)
    },
    getGoodsInfoFail (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.vue-data-loading >>>.loading-header{ display: none!important;}
.empty{ display: block; margin: 0 auto; width: 100%;}
.container-top{ padding: 13px 8px;}
.container-top span{ font-size: 14px; font-family: '微软雅黑'; color: #fd5a0d; background-color: #fff; padding: 10px 2px; padding-right: 0; font-weight: bold; letter-spacing: 1px;}
.container-top .groom{ color: #333; padding-left: 0;}
.container-top .font{ padding: 10px; color: #7f7f7f; padding-right: 40px; font-weight: normal; font-size: 13px; letter-spacing: 0;}
.detail{ overflow: hidden;}
.detail img{ float: left; margin: 10px 15px; border-radius: 5px; margin-right: 8px; width: 80px; height: 80px;}
.detail h5{ font-weight: normal; padding: 12px 20px 3px 0; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
.detail p{ font-size: 12px; color: #656565;}
.dollars{ display: block; margin-top: 2px; color: #fd5a0f; font-size: 12px;}
.price{ font-size: 14px;}
</style>



// WEBPACK FOOTER //
// src/pages/goods/components/List.vue